export default "__VITE_ASSET__CjWxRGk5__"